import { asyncTimeout } from "@use/async-timeout";
import { hrtime } from "@use/universal-hrtime";

/**
 * Used an any async method to ensure that it's promise wont be resolved until
 * the defined minium duration has elapsed.
 */
export const minDuration = (duration: number) => {
    return (target: {}, propertyKey: string, descriptor: PropertyDescriptor) => {
        return {
            // Forward configurable and enumerable "as is"
            configurable: descriptor.configurable,
            enumerable: descriptor.enumerable,

            // Now override the method signature, to ensure that minimum
            // duration has elapsed before resolving the returned promise
            async value(...args: unknown[]): Promise<any> { // tslint:disable-line no-any
                const startedAt = hrtime();

                try {
                    // Start by running the original callback and cache it's
                    // response, so we can forward it to the caller
                    // tslint:disable-next-line no-invalid-this
                    const result = <unknown> (<(...args: unknown[]) => Promise<unknown>> descriptor.value).call(this, ...args);

                    // Now wait for the minimum duration to elapse, before the
                    // response is forwarded...
                    await asyncTimeout(duration - (hrtime() - startedAt));

                    return result;
                } catch (err) {
                    // If an exception was thrown while running the original
                    // callback, the above [[asyncTimeout]] is never triggered - we
                    // need to ensure that errors also wait for the specified
                    // minimum duration before being thrown!
                    await asyncTimeout(duration - (hrtime() - startedAt));

                    throw err;
                }
            },
        };
    };
};
